// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FilterCategory_wrapper__3CQ2r","header":"FilterCategory_header__1AEi6","content":"FilterCategory_content__3LUSz"};